import React from 'react';
import styled from 'styled-components';
//
import BasicFormData from '../BasicFormData';
import OpenNoNeedRadioButton from '../OpenNoNeedRadioButton';
import ExtendedForm from './ExtendedForm';
import SendEmail from '../SendEmail';
import FixaceForm from '../FixaceForm';

export default class HlidacForm extends React.Component {
  state = {
    name: '',
    ico: '',
    jednotka: '',
    tel: '',
    email: '',
    open: 'ano',
    delkaFixace: '',
    puvodniUver: '',
    jistina: '',
    splatka: '',
    fixace: '',
    uzavreni: '',
    ucel: '',
    threeYears: false,
    fiveYears: false,
    tenYears: false,
    fiveteenYears: false,
    jine: false,
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleChecked = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  render() {
    const {
      name,
      ico,
      jednotka,
      tel,
      email,
      open,
      delkaFixace,
      puvodniUver,
      jistina,
      splatka,
      fixace,
      uzavreni,
      ucel,
      threeYears,
      fiveYears,
      tenYears,
      fiveteenYears,
      jine,
    } = this.state;

    const data = {
      formName: 'Hlídač fixace',
      jmeno: name,
      ico,
      jednotka,
      tel,
      email,
      puvodniUver,
      jistina,
      splatka,
      fixace,
      uzavreni,
      uceUveru: ucel,
      delkaFixace: {
        threeYears,
        fiveYears,
        tenYears,
        fiveteenYears,
        jine,
      },
    };

    return (
      <PageContainer>
        <h1>Nastavení hlídače</h1>
        <Form>
          <BasicFormData
            ico={ico}
            jednotka={jednotka}
            name={name}
            tel={tel}
            email={email}
            onChange={this.handleChange}
          />
          <OpenNoNeedRadioButton open={open} onOpenNoNeed={this.handleChange('open')} />
          {open === 'ano' && (
            <React.Fragment>
              <ExtendedForm
                puvodniUver={puvodniUver}
                jistina={jistina}
                splatka={splatka}
                fixace={fixace}
                delkaFixace={delkaFixace}
                uzavreni={uzavreni}
                ucel={ucel}
                onChange={this.handleChange}
              />
              <FixaceForm
                fiveYears={fiveYears}
                tenYears={tenYears}
                fiveteenYears={fiveteenYears}
                threeYears={threeYears}
                jine={jine}
                onChecked={this.handleChecked}
                title=' Fixace úrokové sazby sjednána na:'
              />
            </React.Fragment>
          )}
          <SendEmail data={data} disabled={(name && ico && jednotka && tel && email).length < 1} />
        </Form>
      </PageContainer>
    );
  }
}

const Form = styled.div`
  width: 100%;
  max-width: 600px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;
const PageContainer = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
  @media (max-width: 450px) {
    padding: 24px 2%;
  }
`;
